import React, { Component } from 'react';
import { TabContent, TabPane, FormFeedback, InputGroupAddon, InputGroupText, UncontrolledTooltip, NavItem, Alert, NavLink, Nav, Form, FormGroup, Label, Row, Col, Input, Button, InputGroup, Card, CardBody } from 'reactstrap';
import { Global } from '~/App';
import _ from 'underscore';
import ModalImagen from '~/components/ModalImagen'
import ModalPorQue from '~/components/ModalPorQue'
import Turnstile from '~/components/Turnstile';
import API from '~/API';
import Autosuggest from 'react-autosuggest';


export default class IngresaCuenta extends Component {
  constructor(props) {
    super(props);
    const allowedEmpresas = Global.empresas.filter(e => 
      props.Usuario || !Global.isAnonBlocked(e.key)
    );
    const defaultEmpresa = allowedEmpresas.some(e => e.key === Global.empresaDefecto) 
      ? Global.empresaDefecto 
      : (allowedEmpresas[0]?.key || "");

    this.state = {
      active: 1,
      empresa: defaultEmpresa,
      mensajes: [],
      servicio: "",
      documento: "", // Añadido para controlar el input
      consultando: false,
      //busqueda direccion
      comuna: "",
      calle: "",
      noCasa: "",
      noDpto: "",
      noCasa2: "",
      calles: [],
      callesSinFiltrar: [],
      comunas: [],
      comunasSinFiltrar: []
    }
    this.captchaRef = React.createRef();
    this.pendingSubmit = null;
    this.onCaptchaResolved = this.onCaptchaResolved.bind(this);
    this.onCaptchaError = this.onCaptchaError.bind(this);
  }

  componentWillMount() {
    this.GetCalles();
    this.GetComunas();
  }

  componentWillReceiveProps(props) {
    if (this.state.calles.length == 0 && !this.state.calle)
      this.setState({ calles: this.state.callesSinFiltrar });
    if (this.state.comunas.length == 0 && !this.state.comuna)
      this.setState({ comunas: this.state.comunasSinFiltrar });
  }
  GetCalles() {
    API.Call(`Consulta/${this.state.empresa}/Calles`)
      .then((callesSinFiltrar) => {
        this.setState({ callesSinFiltrar });
      });
  }

  onChangeAddress(event, { newValue }) {
    this.setState({
      calle: newValue
    });
  }
  normalizeText(str){
    return (str||"").toUpperCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9\s]/g, '')
  }
  onSuggestionsFetchRequested({ value }) {
    this.setState({ calles: _.filter(this.state.callesSinFiltrar, (e) => { return this.normalizeText(e.NomCalle).includes(this.normalizeText(value)); }) });
  }

  GetSuggestionValue(suggestion) {
    return suggestion.NomCalle;
  }

  RenderSuggestion(suggestion) {
    return (
      <span>{suggestion.NomCalle}</span>
    );
  }

  DebouncedBuscarCalles({ value, reason }) {
    if (reason == 'type') {
      this.setState({ calles: _.filter(this.state.callesSinFiltrar, (e) => { e.NomCalle.includes(value) }) })
    }
  }
  GetComunas() {
    API.Call(`Consulta/${this.state.empresa}/Comunas`)
      .then((comunasSinFiltrar) => {
        this.setState({ comunasSinFiltrar });
      });
  }
  cambiarEmpresa(e) {
    var self = this;
    this.setState({ empresa: e.target.value }, () => { self.GetComunas(); self.GetCalles(); });
  }
  onChangeComuna(event, { newValue }) {
    this.setState({
      comuna: newValue
    });
  }
  onSuggestionsFetchRequestedComuna({ value }) {
    this.setState({ comunas: _.filter(this.state.comunasSinFiltrar, (e) => { return this.normalizeText(e.NomComuna).includes(this.normalizeText(value)); }) });
  }

  GetSuggestionValueComuna(suggestion) {
    return suggestion.NomComuna;
  }

  RenderSuggestionComuna(suggestion) {
    return (
      <span>{suggestion.NomComuna}</span>
    );
  }

  DebouncedBuscarComuna({ value, reason }) {
    if (reason == 'type') {
      this.setState({ comuna: _.filter(this.state.comunasSinFiltrar, (e) => { e.NomComuna.includes(value) }) })
    }
  }
  
  handleFormSubmit(e, tipo) {
    e.preventDefault();
    const { servicio, documento, empresa, comuna, calle, noCasa, noDpto } = this.state;
    let savedToken = null;
    if (tipo === 'servicio' && servicio) {
      try {
        const key = `anonToken_${empresa}_${servicio}`;
        const raw = sessionStorage.getItem(key);
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            if (parsed && parsed.token && parsed.ts && (Date.now() - parsed.ts < 20 * 60 * 1000)) {
              savedToken = parsed.token;
            } else if (typeof parsed === 'string') {
              savedToken = parsed;
            } else {
              sessionStorage.removeItem(key);
            }
          } catch {
            savedToken = raw;
          }
        }
      } catch {}
    }

    if (tipo === 'servicio') {
      let mensajes = [];
      let valido = true;

      if (servicio === "") {
        mensajes.push({ tipo: "warning", texto: "Debes indicar número de cuenta" });
        valido = false;
      }
      if (!Global.csd && documento === "") {
        mensajes.push({ tipo: "warning", texto: "Debes indicar número de documento" });
        valido = false;
      }
      if (servicio && parseInt(servicio) > 2147483647) {
        mensajes.push({ tipo: "warning", texto: "Número de cuenta muy grande" });
        valido = false;
      }
      if (documento && parseInt(documento) > 9223372036854775807) {
        mensajes.push({ tipo: "warning", texto: "Número de documento muy grande" });
        valido = false;
      }

      this.setState({ mensajes });
      if (!valido) return;

      if (savedToken || !Global.csd) {
        this.ejecutarConsulta(tipo, { empresa, servicio, documento, token: savedToken });
        return;
      }

      this.setState({ consultando: true });
      this.pendingSubmit = { tipo, payload: { empresa, servicio, documento } };
      if (this.captchaRef.current) {
        this.captchaRef.current.execute();
      }
    } else if (tipo === 'direccion') {
      if (!calle || !noCasa || !comuna) return;

      if (!Global.csd) {
        this.ejecutarConsulta(tipo, { empresa, comuna, calle, noCasa, noDpto });
        return;
      }

      this.setState({ consultando: true });
      this.pendingSubmit = { tipo, payload: { empresa, comuna, calle, noCasa, noDpto } };
      if (this.captchaRef.current) {
        this.captchaRef.current.execute();
      }
    }
  }

  onCaptchaError() {
    this.pendingSubmit = null;
    this.setState({ consultando: false });
  }

  onCaptchaResolved(captchaToken) {
    if (!captchaToken || !this.pendingSubmit) return;
    const { tipo, payload } = this.pendingSubmit;
    this.pendingSubmit = null;
    this.setState({ consultando: false });
    this.ejecutarConsulta(tipo, { ...payload, captcha: captchaToken });
  }

  ejecutarConsulta(tipo, payload) {
    if (this.props.onConsultar) {
      this.props.onConsultar({ tipo, payload });
    } else {
      this.props.history.push({
        pathname: '/paga',
        state: payload
      });
    }
  }


  render() {
    const allowedEmpresas = Global.empresas.filter(e => 
      this.props.Usuario || !Global.isAnonBlocked(e.key)
    );

    let hasValidToken = false;
    let hasValidDirToken = false;
    try {
      hasValidToken = Boolean(this.state.servicio && sessionStorage.getItem(`anonToken_${this.state.empresa}_${this.state.servicio}`));
      hasValidDirToken = Boolean(sessionStorage.getItem(`anonToken_${this.state.empresa}`));
    } catch {}

    const empresaSelector = (allowedEmpresas.length > 1 &&
        <FormGroup>
            <Label for="empresa">Empresa</Label>
            <Input name="empresa" type="select" value={this.state.empresa} onChange={this.cambiarEmpresa.bind(this)}>
                {allowedEmpresas.map((e, i) => <option key={i} value={e.key}>{e.nombre}</option>)}
            </Input>
        </FormGroup>
    );

    return (
      <Row>
        <Col sm="12">
          <div className="ingresa-cuenta-container">
            {Global.buscaDireccion &&
              <Nav tabs className="custom-tabs">
                <NavItem>
                  <NavLink active={this.state.active === 1} onClick={() => this.setState({ active: 1 })}>
                    Número de Cuenta
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink active={this.state.active === 2} onClick={() => this.setState({ active: 2 })}>
                    Dirección
                  </NavLink>
                </NavItem>
              </Nav>
            }
            <TabContent activeTab={this.state.active} className="p-4">
              <TabPane tabId={1}>
                {empresaSelector}
                <Form onSubmit={e => this.handleFormSubmit(e, 'servicio')}>
                    <FormGroup>
                        <Label for="servicio">
                            <span>Número de Cuenta</span>
                            <ModalPorQue />
                        </Label>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend"><InputGroupText>👤</InputGroupText></InputGroupAddon>
                            <Input className="text-right" value={this.state.servicio} onChange={e => this.setState({ servicio: e.target.value })} type="number" name="servicio" placeholder="Ingresa tu número de cuenta" />
                            <InputGroupAddon id="asyntecPortalDVServicio" addonType="append">
                                <Button type="button" size="sm" color="link" disabled>{this.state.servicio ? <div> - {Global.DV(this.state.servicio)}</div> : <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>}</Button>
                                <UncontrolledTooltip placement="top" target="asyntecPortalDVServicio">Dígito Verificador</UncontrolledTooltip>
                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>

                    {!Global.csd &&
                        <FormGroup>
                            <Label for="documento">
                                <span>Número de Documento</span>
                                <ModalImagen empresa={this.state.empresa} />
                            </Label>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend"><InputGroupText>📄</InputGroupText></InputGroupAddon>
                                <Input type="number" name="documento" placeholder="Requerido para validar" value={this.state.documento} onChange={e => this.setState({ documento: e.target.value })} />
                            </InputGroup>
                        </FormGroup>
                    }
                    
                    {this.state.mensajes.map((m, i) => <Alert key={i} color={m.tipo} className="text-center">{m.texto}</Alert>)}
                    
                    <Button block disabled={!this.state.servicio || this.state.consultando} type="submit" color="primary" size="lg">
                        {this.state.consultando ? 'Consultando...' : 'Consultar'}
                    </Button>
                </Form>
              </TabPane>

              {Global.buscaDireccion &&
                <TabPane tabId={2}>
                  {empresaSelector}
                  <Form autoComplete="off" onSubmit={e => this.handleFormSubmit(e, 'direccion')}>
                    <FormGroup>
                        <Label for="calle">Calle</Label>
                        <Autosuggest
                            suggestions={this.state.calles}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
                            onSuggestionsClearRequested={() => {}}
                            getSuggestionValue={this.GetSuggestionValue.bind(this)}
                            renderSuggestion={this.RenderSuggestion.bind(this)}
                            inputProps={{ autoComplete:"off", placeholder: "Ej: Av. Providencia", value: this.state.calle, onChange: this.onChangeAddress.bind(this), name: "calle", className: 'form-control' }}
                            theme={{
                                container: 'react-autosuggest__container',
                                input: `form-control ${this.state.calle === '' ? 'is-invalid' : ''}`,
                                suggestionsContainer: 'react-autosuggest__suggestions-container',
                                suggestion: 'react-autosuggest__suggestion',
                                suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
                                suggestionsList: 'list-group'
                            }}
                        />
                         <Input invalid={this.state.calle === ""} hidden />
                         <FormFeedback>La calle es requerida</FormFeedback>
                    </FormGroup>
                    <Row form>
                        <Col md={8}>
                            <FormGroup>
                                <Label for="noCasa">Número</Label>
                                <Input invalid={this.state.noCasa === ""} onChange={e => this.setState({ noCasa: e.target.value })} type="text" name="noCasa" placeholder="Ej: 1234"/>
                                <FormFeedback>El número es requerido</FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="noDpto">Dpto / Casa</Label>
                                <Input onChange={e => this.setState({ noDpto: e.target.value })} type="text" name="noDpto" placeholder="Opcional"/>
                            </FormGroup>
                        </Col>
                    </Row>
                     <FormGroup>
                        <Label for="comuna">Comuna</Label>
                        <Autosuggest
                            suggestions={this.state.comunas}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedComuna.bind(this)}
                            onSuggestionsClearRequested={() => {}}
                            getSuggestionValue={this.GetSuggestionValueComuna.bind(this)}
                            renderSuggestion={this.RenderSuggestionComuna.bind(this)}
                            inputProps={{ autoComplete:"off", placeholder: "Ej: Ñuñoa", value: this.state.comuna, onChange: this.onChangeComuna.bind(this), name: "comuna", className: 'form-control' }}
                             theme={{
                                container: 'react-autosuggest__container',
                                input: `form-control ${this.state.comuna === '' ? 'is-invalid' : ''}`,
                                suggestionsContainer: 'react-autosuggest__suggestions-container',
                                suggestion: 'react-autosuggest__suggestion',
                                suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
                                suggestionsList: 'list-group'
                            }}
                        />
                         <Input invalid={this.state.comuna === ""} hidden />
                         <FormFeedback>La comuna es requerida</FormFeedback>
                    </FormGroup>
                    <Button block type="submit" color="primary" size="lg" disabled={!this.state.calle || !this.state.noCasa || !this.state.comuna || this.state.consultando}>
                        {this.state.consultando ? 'Consultando...' : 'Consultar'}
                    </Button>
                  </Form>
                </TabPane>}
            </TabContent>
            <Turnstile
                ref={this.captchaRef}
                size="invisible"
                sitekey={Global.apiKeyCaptcha}
                onChange={this.onCaptchaResolved}
                onErrored={this.onCaptchaError}
                onExpired={this.onCaptchaError}
            />
          </div>
        </Col>
      </Row>
    )
  }
}